module.exports = __webpack_public_path__ + "a3dbf46aaf3003357e1c4285453e5f9d.png";